import {
    MdDashboard,
    MdWarning,
} from 'react-icons/md';
import {
    ImBook
} from 'react-icons/im';
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import { BiMailSend } from "react-icons/bi";
import { BsBellFill } from "react-icons/bs";
import { FaProductHunt, FaShoppingCart } from 'react-icons/fa';

let navItem = {
    dashboar: [
        { to: '/admin', name: 'home', exact: "false", Icon: MdDashboard }
    ],
    agency: [
        { to: '/admin/dai-ly/nap-tien.html', name: 'rechargeCredit', title: 'Nạp tiền', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/dai-ly/lich-su-nap-tien.html', name: 'historyCredit', title: 'Lịch sử nạp tiền', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/dai-ly/lich-su-giao-dich.html', name: 'historyPayment', title: 'Lịch sử giao dịch', exact: "false", Icon: RiCheckboxBlankCircleLine },
    ],
    user: [
        { to: '/admin/khach-hang', name: 'userList', title: 'Khách hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/nhom-khach-hang', name: 'groupUser', title: 'Nhóm khách hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    ],
    product: [
        { to: '/admin/san-pham', name: 'productList', title: 'Danh sách sản phẩm', exact: "false", Icon: FaProductHunt },
    ],
    order: [
        { to: '/admin/don-dat-hang', name: 'orderList', title: 'Danh sách đơn hàng', exact: "false", Icon: FaShoppingCart },
        // { to: '/admin/don-dat-hang/tao-don-hang', name: 'orderCreate', title: 'Tạo đơn hàng', exact: "false", Icon: RiCheckboxBlankCircleLine },
    ],
    email: [
        { to: '/admin/system-email', name: 'listSystemEmail', title: 'Email hệ thống', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/email/danh-sach-email-dich-vu.html', name: 'listServiceEmail', title: 'Email dịch vụ', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    log: [
    	{ to: '/admin/activity-log', name: 'listLog', title: 'List', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    ticket: [
        { to: '/admin/ticket', name: 'listTicket', title: 'Ticket', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    config_system: [
        { to: '/admin/config-system', name: 'configSystem', title: 'Cài đặt hệ thống', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/auto-banking', name: 'autoBanking', title: 'Auto Banking', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    auto_banking: [
        { to: '/admin/auto-banking', name: 'autoBanking', title: 'Auto Banking', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    payment: [
        { to: '/admin/quan-ly-giao-dich/nap-tien-tai-khoan.html', name: 'rechargeCredit', title: 'Nạp tiền tài khoản', exact: "false", Icon: RiCheckboxBlankCircleLine },
        // { to: '/admin/quan-ly-giao-dich/giao-dich-tao-moi.html', name: 'createPayment', title: 'Giao dịch tạo mới', exact: "false", Icon: RiCheckboxBlankCircleLine },
        // { to: '/admin/quan-ly-giao-dich/giao-dich-nang-cap.html', name: 'upgradePayment', title: 'Giao dịch nâng cấp', exact: "false", Icon: RiCheckboxBlankCircleLine },
        // { to: '/admin/quan-ly-giao-dich/giao-dich-gia-han.html', name: 'expirePayment', title: 'Giao dịch gia hạn', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/quan-ly-giao-dich/tat-ca-giao-dich.html', name: 'allPayment', title: 'Danh sách giao dịch', exact: "false", Icon: RiCheckboxBlankCircleLine },
    ],
    infomation: [
        { to: '/admin/tutorial', name: 'tutorialList', title: 'Hướng dẫn', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/ticket', name: 'listTicket', title: 'Ticket', exact: 'false', Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/send-mail', name: 'sendMailList', title: 'Send mail', exact: "false", Icon: RiCheckboxBlankCircleLine },
        { to: '/admin/activity-log', name: 'listLog', title: 'Activity Log', exact: 'false', Icon: RiCheckboxBlankCircleLine }
    ],
    alert_admin: [
        { to: '/admin/alert-admin', name: 'alertAdminList', title: 'Cảnh báo', exact: "false", Icon: MdWarning }
    ], 
    tutorial: [
        { to: '/admin/tutorial', name: 'tutorialList', title: 'Quản lý hướng dẫn', exact: "false", Icon: ImBook }
    ], 
    send_mail: [
        { to: '/admin/send-mail', name: 'sendMailList', title: 'Quản lý gửi mail', exact: "false", Icon: BiMailSend }
    ],
    noti_admin: [
        { to: '/admin/noti-admin', name: 'notiAdminList', title: 'Thông báo', exact: "false", Icon: BsBellFill }
    ]
};

export default navItem;